import React, { useEffect } from 'react';
import App from '@app';
import { Body, PageHeader } from '@components';
import ReactJson from 'react-json-view';
import { useParams } from 'react-router-dom';
import { getProcesso, reset } from '@ducks/logsTempos';
import { useSelector, useDispatch } from 'react-redux';

export default function Detalhamento() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const handleSearch = () => {
    dispatch(getProcesso({ id }));
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const processo = useSelector(({ logsTempos }) => logsTempos.get('processo'));

  return (
    <App>
      <Body>
        <PageHeader
          title={`Processos Web - ${id}`}
          onBack={() => {
            dispatch(reset());
            window.history.back();
          }}
        >
          <ReactJson src={processo} displayDataTypes={false} name='processo' />
        </PageHeader>
      </Body>
    </App>
  );
}
